var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvisoprivacidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f0f3;}.cls-2{fill:#fff;}.cls-3{fill:#ffc144;}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.24,100.79c-.6,0-72.61,.66-72.61,.06V30.7l.14-20.91H90.28c.6,0,1.09,.49,1.09,1.09V75.73l-.14,25.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.8,98.01V27.86h-9.12V98.01c0,.6,.49,1.09,1.09,1.09h9.12c-.6,0-1.09-.49-1.09-1.09h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "46.62 8.9 91.24 8.9 91.24 100.79 18.76 100.79 18.76 8.9 35.77 8.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g3931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3959",
    className: "cls-4",
    d: "M69.24,46.13c.43-1.31,.67-2.72,.67-4.18,0-7.25-5.75-13.12-12.85-13.12s-12.85,5.88-12.85,13.12c0,1.45,.23,2.85,.66,4.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3963",
    className: "cls-3",
    d: "M43.36,79.28c-2.76,0-4.99-2.23-4.99-4.99v-21.93c0-2.76,2.23-4.99,4.99-4.99h27.39c2.76,0,4.99,2.23,4.99,4.99v21.93c0,2.76-2.23,4.99-4.99,4.99h-27.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3967",
    className: "cls-4",
    d: "M43.36,79.28c-2.76,0-4.99-2.23-4.99-4.99v-21.93c0-2.76,2.23-4.99,4.99-4.99h27.39c2.76,0,4.99,2.23,4.99,4.99v21.93c0,2.76-2.23,4.99-4.99,4.99h-27.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3971",
    className: "cls-4",
    d: "M57.41,60.64v5.37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvisoprivacidad);
export default __webpack_public_path__ + "static/media/avisoprivacidad.5c6e3336db4f72269e9433e8461c7c70.svg";
export { ForwardRef as ReactComponent };